import styles from './style.module.css';
import {SearchInput} from './components/search-input';
import {SearchSort} from './components/search-sort';
import { FilterButton } from '../../../navbar/components/filter-button';

export const SearchBar = () => {
    
    return <div className={styles.SearchBar}>

       <SearchInput />
       <FilterButton />
       <SearchSort />

    </div>

};




